<ion-card
  [attr.data-cy]="imageItem.tag"
  [disabled]="imageItem.disabled"
  (click)="onClick()"
  [class.clickable]="!imageItem.disabled"
  [class.mobile]="platform === platformRef.mobile"
>
  <div class="img-container" *ngIf="platform !== platformRef.mobile">
    <ion-img [src]="imageItem.imageUrl"></ion-img>
  </div>

  <div class="descriptive">
    <p class="card-title">
      {{ imageItem.title | translate }}
    </p>
    <p class="card-subtitle">
      {{ imageItem.label | translate }}
    </p>
  </div>
</ion-card>
